import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from "@mui/material/Box";
import Header from "../Header/Header";
import TabContent from "../Content/TabContent";
import { getAccessToken } from '../Redux/TokenSlice';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getRoles } from '../Redux/RoleSlice';
import Spinner from '../Spinner/Spinner';
import NotAuthorized from '../NotAuthorized/NotAuthorized';
import { authLoading } from "../Redux/AccessTokenSlice";
import CommonError from '../GeneralError/GeneralError';

function Page() {
    const dispatch = useDispatch();
    const isAuthorized = true;
    const isActive = useSelector(state => state.role.isActive);
    const cns = useSelector(state => state.role.cns);
    const mnr = useSelector(state => state.role.mnr);
    const loading = useSelector(state => state.role.loading);
    const loadingToken = useSelector(state => state.token.loading);
    const reports = useSelector(state => state.role.reports);
     const isAuthenticated =sessionStorage.getItem("isAuthenticated");
    const [error, setError] = useState(false);
    const tokenError = useSelector(state => state.accessToken.error);
    const roleError = useSelector(state => state.role.error);

    useEffect(() => {
        const checkAuthorization = async () => {
            try {
                await dispatch(getRoles());
            } catch (error) {
                console.log("Authorization API Failed:", error);
                setError(true);
                dispatch(authLoading(false));
                return;
            }
        }
        if (isAuthorized) {
            try {
                dispatch(getAccessToken()).then(() => {
                    if (isAuthenticated) {
                        checkAuthorization();
                    }
                });
            }
            catch (error) {
                setError(true);
                console.log("Token API Failed:", error);
                dispatch(authLoading(false));
                return;
            }
        }
    }, [dispatch, isAuthenticated, isAuthorized])

    if (loading) {
        return (
            <Spinner />
        )
    }
    else if (!loadingToken && !loading && (error || tokenError || roleError)) {
        return (
            <CommonError />
        )
    }
    else if (isAuthenticated && isActive && (cns || mnr || reports)) {
        return (
            <div>
                <Box sx={{ display: 'flex' }}>
                    <Header />
                    <ToastContainer position="top-right" autoClose={5000} />
                    <Box sx={{ width: '100%' }} style={{ marginTop: '50px' }}>
                        <Box>
                            <div style={{ background: 'linear-gradient(to right,#c3373f,#e6a30b)', height: '4px' }}></div>
                        </Box>
                        {<TabContent />}
                    </Box>
                </Box>
            </div>
        )
    }
    else if (!loadingToken && !loading && (!isAuthorized || !isAuthenticated || !isActive || !(cns || mnr || reports))) {
        return (
            <div>
                <Box sx={{ display: 'flex' }}>
                    <Box sx={{ width: '100%' }}>
                        <NotAuthorized />
                    </Box>
                </Box>
            </div>
        )
    }
}

export default Page;